import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const apiClient = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json',
  },
});

apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default apiClient;

export const authAPI = {
  register: (data) => apiClient.post('/auth/register', data),
  login: (data) => apiClient.post('/auth/login', data),
  getMe: () => apiClient.get('/auth/me'),
};

export const productsAPI = {
  getAll: (params) => apiClient.get('/products', { params }),
  getById: (id) => apiClient.get(`/products/${id}`),
  getPriceHistory: (id) => apiClient.get(`/products/${id}/price-history`),
};

export const brandsAPI = {
  register: (data) => apiClient.post('/brands/register', data),
  getDashboard: () => apiClient.get('/brands/dashboard'),
  uploadProduct: (data) => apiClient.post('/products/upload', data),
  getPriceSuggestion: (id) => apiClient.post(`/ai/price-suggestion/${id}`),
};

export const ordersAPI = {
  create: (data) => apiClient.post('/orders/create', data),
  getAll: () => apiClient.get('/orders'),
};

export const membershipAPI = {
  getPlans: () => apiClient.get('/memberships/plans'),
  createCheckout: (data) => apiClient.post('/memberships/checkout-session', data),
  getCheckoutStatus: (sessionId) => apiClient.get(`/memberships/checkout-status/${sessionId}`),
};

export const paymentsAPI = {
  createCheckout: (data) => apiClient.post('/payments/checkout-session', data),
  getCheckoutStatus: (sessionId) => apiClient.get(`/payments/checkout-status/${sessionId}`),
};

export const adminAPI = {
  getPendingBrands: () => apiClient.get('/admin/brands/pending'),
  approveBrand: (id) => apiClient.post(`/admin/brands/${id}/approve`),
  rejectBrand: (id) => apiClient.post(`/admin/brands/${id}/reject`),
  getPendingProducts: () => apiClient.get('/admin/products/pending'),
  approveProduct: (id) => apiClient.post(`/admin/products/${id}/approve`),
  getKPIs: () => apiClient.get('/admin/kpis'),
  updateCommission: (id, rate) => apiClient.post(`/admin/brands/${id}/commission`, { commission_rate: rate }),
};

export const aiAPI = {
  getRecommendations: () => apiClient.get('/ai/recommendations'),
};
